<template>
  <div>
    <ui-stage>
      <ui-button icon="el-icon-refresh" @click="fetchData">刷新</ui-button>
      <ui-admin-table
        v-if="data"
        :attributes="attributes"
        :data="data"
        pagination-method="front-end"
        :with-create="false"
        :with-delete="false"
      >
        <template v-slot:column__adminActions="{ row }">
          <router-link :to="row.link" target="_blank">
            <ui-button size="mini" type="primary" icon="el-icon-view">审核</ui-button>
          </router-link>
        </template>
      </ui-admin-table>
    </ui-stage>
  </div>
</template>

<script>
import { adminList } from '@yishitec/web/mixins';
import permissions from '../../../mixins/permissions';

export default {
  name: 'Tasks',
  mixins: [adminList, permissions],
  data() {
    return {
      vvApi: '/api/tasks/list',
    };
  },
};
</script>

<style lang="less" scoped></style>
